import React,{useEffect, useState} from "react";

// MUI Components
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";

// icons
// import ArrowDropDownCircleOutlinedIcon from '@mui/icons-material/ArrowDropDownCircleOutlined';
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';

// Styled comp:
import { styled } from '@mui/material/styles';
import { Button } from "@mui/material";

const PanelTitle = styled(Typography)({
    // variants:'h4'

});
const PanelHeader = styled(Box)({
    display:'flex',
    flexDirection:'row',
    alignItems:'center',
    fontWeight:'bold'

});
const PanelContent = styled(Box)({
    height:'auto',
    width:'100%'

});
const PanelContainer = styled(Box)({
    // width:'auto',
    // height:'100%',
    // [`& ${PanelHeader}`]: ({}),
    // [`& ${PanelContent}`]: ({})

});

function ColapsePanel({sPanelTitle,children, defaultOpen}){

    useEffect(() => {
        if(defaultOpen) { setOpen(defaultOpen)}
    },[defaultOpen])

    const[bOpen,setOpen] = useState(false);

    const onPanelClick =  (oEvent) => {
        setOpen(!bOpen)

    }

return(

    <PanelContainer onClick={onPanelClick}>
        <PanelHeader >
            <KeyboardArrowLeftOutlinedIcon sx={{display: bOpen ? 'none' : 'block' }}/>
            <KeyboardArrowDownOutlinedIcon sx={{display: !bOpen ? 'none' : 'block' }}/>
          <PanelTitle variant="h5">{sPanelTitle}</PanelTitle>
        </PanelHeader>
        <Collapse in={bOpen}>
            {children}
        </Collapse>
    </PanelContainer>

)
}

export default ColapsePanel;


        // <PanelHeader >
        //  <KeyboardArrowLeftOutlinedIcon sx={{display: bOpen ? 'none' : 'block' }}/>
        //  <KeyboardArrowDownOutlinedIcon sx={{display: !bOpen ? 'none' : 'block' }}/>
        //  <PanelTitle>{sPanelTitle}</PanelTitle>
        // </PanelHeader>
        // <Box onClick={onPanelClick}>click me</Box>
        // <Collapse open={true}>
        // {/* {children} */}
        //     <Box>Hi</Box>
        //     <PanelContent>{children}</PanelContent>
        // </Collapse>